import { useCallback, useState } from 'react';
import { useTranslation } from '../components/blocks';
import { usePageMessaging } from '../components/composites';
import { exportSalesOrderDemands } from '../redux/actions/salesOrderDemandActionCreators';
import { SalesOrderDemandFilter } from '../redux/types';
import { formatTimestampCompact } from '../utils/dateUtils';
import { Logger } from '../utils/logger';
import { useDownloader } from '../utils/useDownloader';

export const useExportSalesOrderDemands = () => {
    const { t } = useTranslation(['purchaseOrderListPage']);
    const { downloadB64Object } = useDownloader();
    const { showSuccess, showError } = usePageMessaging();
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = useCallback(
        async (
            resellerId: string,
            filters: SalesOrderDemandFilter | undefined,
            filenamePrefix: string,
            locale: string | undefined,
            itemCount: number,
            resellerIanaTimezone?: string
        ) => {
            setIsExporting(true);
            const filename = `${filenamePrefix}_${resellerId}_${formatTimestampCompact()}.xlsx`;
            try {
                const result = await exportSalesOrderDemands(resellerId, filters, locale, resellerIanaTimezone);
                downloadB64Object(filename, result.content, result.contentType);
                showSuccess(t('export-successMessage', { count: itemCount }));
            } catch (error) {
                Logger.error(`Failed to export: ${filename}`, error);
                showError(t('export-errorMessage', { count: itemCount }));
            } finally {
                setIsExporting(false);
            }
        },
        [downloadB64Object, showSuccess, t, showError]
    );

    return { isExporting, handleExport };
};
